// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-16px);
  }
  60% {
    transform: translateY(-7px);
  }
}

.option {
  margin-bottom: 2em;
}

.option p {
  margin-bottom: 0;
}

.bounce {
  animation-name: bounce;
}

#forkongithub a {
  background: #990033;
  color: #fff;
}

.project_container a {
  color: #000;
}

.clearfix:before,
.clearfix:after {
  display: block;
  content: "";
  line-height: 0;
  clear: both;
}

.taggle_list {
  float: left;
  width: 100%;
  margin: 0;
}

.taggle_input {
  border: none;
  outline: none;
  font-size: 16px;
  font-weight: 300;
}

.taggle_list li {
  float: left;
  display: inline-block;
  white-space: nowrap;
  font-weight: 500;
  margin-bottom: 5px;
}

.taggle_list .taggle {
  margin-right: 8px;
  line-height: 1;
  background: #e2e1df;
  padding: 5px 10px;
  border-radius: 3px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
  animation-duration: 1s;
  animation-fill-mode: both;
}

.taggle_list .taggle_hot {
  background: #cac8c4;
}

.taggle_list .taggle .close {
  font-size: 1.1rem;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 3px;
  text-decoration: none;
  padding-left: 2px;
  padding-top: 3px;
  line-height: 14px;
  color: #ccc;
  color: rgba(0, 0, 0, 0.2);
  padding-bottom: 4px;
  display: none;
  border: 0;
  background: none;
  cursor: pointer;
}

.taggle_list .taggle:hover {
  padding: 5px;
  padding-right: 20px;
  background: #ccc;
  transition: all 0.3s;
}

.taggle_list .taggle:hover > .close {
  display: block;
}

.taggle_list .taggle .close:hover {
  color: #990033;
}

.taggle_placeholder {
  position: absolute;
  color: #ccc;
  top: 12px;
  left: 8px;
  transition: opacity, 0.25s;
  -webkit-user-select: none;
  user-select: none;
}

.taggle_input {
  padding: 8px;
  padding-left: 0;
  float: left;
  margin-top: -5px;
  background: none;
  width: 100%;
  max-width: 100%;
}

.taggle_sizer {
  padding: 0;
  margin: 0;
  position: absolute;
  top: -500px;
  z-index: -1;
  visibility: hidden;
}

/*container styles*/
textarea.input,
.textarea.input {
  /*border: 0;*/
  background: #fdfdfd;
  /*box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2),
    0 1px 1px rgba(255, 255, 255, 0.7);*/
  min-height: 60px;
  padding: 8px;
  /*border-radius: 3px;*/
  color: #555;
  transition: all 0.25s;
  cursor: text;
  margin-bottom: 0px; /*2em;*/
  position: relative;
}

.textarea.input:after {
  clear: both;
  content: "";
  display: block;
}

.textarea.input:focus,
.textarea.input.active,
textarea.input:focus,
textarea.input.active {
  background: #fff;
  transition: all 0.25s;
}

.textarea.input,
textarea.input {
  height: auto;
}

.textarea.tags {
  position: relative;
}

.textarea.tags * {
  box-sizing: content-box;
}

.placeholder_input {
  position: relative;
}

.placeholder_input span {
  position: absolute;
  color: #aaa;
  top: 50%;
  margin-top: -11px;
  left: 10px;
}

.placeholder_input input {
  width: 120px;
}

.ui-autocomplete {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  border: 1px solid #eee;
}

.ui-autocomplete li a {
  transition: none !important;
}

.ui-menu {
  list-style: none;
  padding: 2px;
  margin: 0;
  display: block;
  outline: none;
}

.ui-widget-content {
  background: #fff;
  color: #990033;
}

.ui-menu .ui-menu-item {
  margin: 0;
  padding: 0;
  width: 100%;
}

.ui-menu .ui-menu-item a {
  text-decoration: none;
  display: block;
  padding: 2px 0.4em;
  line-height: 1.5;
  min-height: 0;
  font-weight: normal;
  color: #8a8a8a;
  cursor: pointer;
}
.ui-menu .ui-menu-item a:hover {
  color: #fff;
  background: #990033;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus {
  background: #990033;
  color: #fff !important;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited {
  color: #fff;
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active {
  border: 1px solid #aaaaaa;
  background: #ffffff;
  font-weight: normal;
  color: #212121;
}

.ui-helper-hidden {
  display: none;
}

.ui-helper-hidden-accessible {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.autocomplete {
  max-height: 200px;
  overflow: scroll;
  position: absolute;
  top: 66px;
  background: white;
  width: 99.5%;
  left: 0.25%;
  z-index: 200;
}

.autocomplete ul li {
  display: block;
  padding: 6px 8px;
}

.autocomplete ul li.selected,
.autocomplete ul li:hover {
  background: #ff6633;
  color: #fff;
  cursor: pointer;
}

.ui-autocomplete {
  max-height: 200px;
  overflow: scroll;
  width: 99% !important;
}

.custom.textarea {
  border-radius: 0;
  box-shadow: none;
}
.custom.textarea .taggle {
  border-radius: 0;
  padding: 5px;
  padding-right: 20px;
}
.custom.textarea .taggle .close {
  display: inline-block;
  right: 3px;
}

.custom.delicious {
  background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);
  border: 1px solid #aaa;
  min-height: 50px;
}
.custom.delicious.active {
  border-color: #3274d1;
  background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);
}
.custom.delicious .taggle {
  color: #444;
  border-radius: 0;
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
  background-color: #ddd;
  font-family: sans-serif;
  font-size: 0.8rem;
  padding: 5px;
  padding-left: 20px;
}
.custom.delicious .taggle .close {
  color: #aaa;
  font-size: 0.9rem;
  height: 0.7rem;
  width: 0.7rem;
  line-height: 7px;
  margin-top: 0;
  right: auto;
  left: 5px;
}
.custom.delicious .taggle .close:hover {
  color: #888;
}

.custom.stackoverflow {
  border: 1px solid #ccc;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.custom.stackoverflow .taggle {
  color: #3e6d8e;
  border-radius: 0;
  background-color: #e0eaf1;
  font-weight: 200;
  line-height: 1.2;
}
.custom.stackoverflow .taggle.taggle_hot {
  background: #bdd0dd;
}
.custom.stackoverflow .taggle .close {
  color: #aaa;
  border-radius: 50%;
  font-size: 0.9rem;
  height: 0.7rem;
  width: 0.7rem;
  line-height: 9px;
  padding-left: 0;
  padding-top: 1px;
  margin-top: 7px;
}
.custom.stackoverflow .taggle .close:hover {
  background: #c03434;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Cobranza/createAbono.css"],"names":[],"mappings":"AAgBA;EACE;;;;;IAME,wBAAwB;EAC1B;EACA;IAEE,4BAA4B;EAC9B;EACA;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EAEpB,sBAAsB;EAEtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,mBAAmB;EACnB;wCACsC;EACtC,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB,EAAE,OAAO;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,+DAA+D;EAC/D,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,+DAA+D;AACjE;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["@-webkit-keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    -webkit-transform: translateY(0);\n  }\n  40% {\n    -webkit-transform: translateY(-16px);\n  }\n  60% {\n    -webkit-transform: translateY(-7px);\n  }\n}\n\n@keyframes bounce {\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  40% {\n    -webkit-transform: translateY(-16px);\n    transform: translateY(-16px);\n  }\n  60% {\n    -webkit-transform: translateY(-7px);\n    transform: translateY(-7px);\n  }\n}\n\n.option {\n  margin-bottom: 2em;\n}\n\n.option p {\n  margin-bottom: 0;\n}\n\n.bounce {\n  -webkit-animation-name: bounce;\n  animation-name: bounce;\n}\n\n#forkongithub a {\n  background: #990033;\n  color: #fff;\n}\n\n.project_container a {\n  color: #000;\n}\n\n.clearfix:before,\n.clearfix:after {\n  display: block;\n  content: \"\";\n  line-height: 0;\n  clear: both;\n}\n\n.taggle_list {\n  float: left;\n  width: 100%;\n  margin: 0;\n}\n\n.taggle_input {\n  border: none;\n  outline: none;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.taggle_list li {\n  float: left;\n  display: inline-block;\n  white-space: nowrap;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n.taggle_list .taggle {\n  margin-right: 8px;\n  line-height: 1;\n  background: #e2e1df;\n  padding: 5px 10px;\n  border-radius: 3px;\n  position: relative;\n  cursor: pointer;\n  transition: all 0.3s;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.taggle_list .taggle_hot {\n  background: #cac8c4;\n}\n\n.taggle_list .taggle .close {\n  font-size: 1.1rem;\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  right: 3px;\n  text-decoration: none;\n  padding-left: 2px;\n  padding-top: 3px;\n  line-height: 14px;\n  color: #ccc;\n  color: rgba(0, 0, 0, 0.2);\n  padding-bottom: 4px;\n  display: none;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.taggle_list .taggle:hover {\n  padding: 5px;\n  padding-right: 20px;\n  background: #ccc;\n  transition: all 0.3s;\n}\n\n.taggle_list .taggle:hover > .close {\n  display: block;\n}\n\n.taggle_list .taggle .close:hover {\n  color: #990033;\n}\n\n.taggle_placeholder {\n  position: absolute;\n  color: #ccc;\n  top: 12px;\n  left: 8px;\n  transition: opacity, 0.25s;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.taggle_input {\n  padding: 8px;\n  padding-left: 0;\n  float: left;\n  margin-top: -5px;\n  background: none;\n  width: 100%;\n  max-width: 100%;\n}\n\n.taggle_sizer {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  top: -500px;\n  z-index: -1;\n  visibility: hidden;\n}\n\n/*container styles*/\ntextarea.input,\n.textarea.input {\n  /*border: 0;*/\n  background: #fdfdfd;\n  /*box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2),\n    0 1px 1px rgba(255, 255, 255, 0.7);*/\n  min-height: 60px;\n  padding: 8px;\n  /*border-radius: 3px;*/\n  color: #555;\n  transition: all 0.25s;\n  cursor: text;\n  margin-bottom: 0px; /*2em;*/\n  position: relative;\n}\n\n.textarea.input:after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n\n.textarea.input:focus,\n.textarea.input.active,\ntextarea.input:focus,\ntextarea.input.active {\n  background: #fff;\n  transition: all 0.25s;\n}\n\n.textarea.input,\ntextarea.input {\n  height: auto;\n}\n\n.textarea.tags {\n  position: relative;\n}\n\n.textarea.tags * {\n  box-sizing: content-box;\n}\n\n.placeholder_input {\n  position: relative;\n}\n\n.placeholder_input span {\n  position: absolute;\n  color: #aaa;\n  top: 50%;\n  margin-top: -11px;\n  left: 10px;\n}\n\n.placeholder_input input {\n  width: 120px;\n}\n\n.ui-autocomplete {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  border: 1px solid #eee;\n}\n\n.ui-autocomplete li a {\n  transition: none !important;\n}\n\n.ui-menu {\n  list-style: none;\n  padding: 2px;\n  margin: 0;\n  display: block;\n  outline: none;\n}\n\n.ui-widget-content {\n  background: #fff;\n  color: #990033;\n}\n\n.ui-menu .ui-menu-item {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.ui-menu .ui-menu-item a {\n  text-decoration: none;\n  display: block;\n  padding: 2px 0.4em;\n  line-height: 1.5;\n  min-height: 0;\n  font-weight: normal;\n  color: #8a8a8a;\n  cursor: pointer;\n}\n.ui-menu .ui-menu-item a:hover {\n  color: #fff;\n  background: #990033;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus {\n  background: #990033;\n  color: #fff !important;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited {\n  color: #fff;\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active {\n  border: 1px solid #aaaaaa;\n  background: #ffffff;\n  font-weight: normal;\n  color: #212121;\n}\n\n.ui-helper-hidden {\n  display: none;\n}\n\n.ui-helper-hidden-accessible {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.autocomplete {\n  max-height: 200px;\n  overflow: scroll;\n  position: absolute;\n  top: 66px;\n  background: white;\n  width: 99.5%;\n  left: 0.25%;\n  z-index: 200;\n}\n\n.autocomplete ul li {\n  display: block;\n  padding: 6px 8px;\n}\n\n.autocomplete ul li.selected,\n.autocomplete ul li:hover {\n  background: #ff6633;\n  color: #fff;\n  cursor: pointer;\n}\n\n.ui-autocomplete {\n  max-height: 200px;\n  overflow: scroll;\n  width: 99% !important;\n}\n\n.custom.textarea {\n  border-radius: 0;\n  box-shadow: none;\n}\n.custom.textarea .taggle {\n  border-radius: 0;\n  padding: 5px;\n  padding-right: 20px;\n}\n.custom.textarea .taggle .close {\n  display: inline-block;\n  right: 3px;\n}\n\n.custom.delicious {\n  background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);\n  border: 1px solid #aaa;\n  min-height: 50px;\n}\n.custom.delicious.active {\n  border-color: #3274d1;\n  background-image: linear-gradient(to bottom, #eee 1%, #fff 15%);\n}\n.custom.delicious .taggle {\n  color: #444;\n  border-radius: 0;\n  border-top-left-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n  background-color: #ddd;\n  font-family: sans-serif;\n  font-size: 0.8rem;\n  padding: 5px;\n  padding-left: 20px;\n}\n.custom.delicious .taggle .close {\n  color: #aaa;\n  font-size: 0.9rem;\n  height: 0.7rem;\n  width: 0.7rem;\n  line-height: 7px;\n  margin-top: 0;\n  right: auto;\n  left: 5px;\n}\n.custom.delicious .taggle .close:hover {\n  color: #888;\n}\n\n.custom.stackoverflow {\n  border: 1px solid #ccc;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.custom.stackoverflow .taggle {\n  color: #3e6d8e;\n  border-radius: 0;\n  background-color: #e0eaf1;\n  font-weight: 200;\n  line-height: 1.2;\n}\n.custom.stackoverflow .taggle.taggle_hot {\n  background: #bdd0dd;\n}\n.custom.stackoverflow .taggle .close {\n  color: #aaa;\n  border-radius: 50%;\n  font-size: 0.9rem;\n  height: 0.7rem;\n  width: 0.7rem;\n  line-height: 9px;\n  padding-left: 0;\n  padding-top: 1px;\n  margin-top: 7px;\n}\n.custom.stackoverflow .taggle .close:hover {\n  background: #c03434;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
